var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { Button, Grid, InputCheckbox } from '../../../shared';
import './declarations-table.scss';
import { services } from '../../../../shared/api/services';
import { CaseNavigation } from '../../../sections/case-navigation/case-navigation';
import { useHistory } from 'react-router-dom';
import saveAs from 'file-saver';
export var DeclarationsTable = function (_a) {
    var caseId = _a.caseId, formId = _a.formId, data = _a.data, pages = _a.pages, steps = _a.steps, location = _a.location;
    var _b = useState([]), declarations = _b[0], setDeclarations = _b[1];
    var _c = useState(), documentUrl = _c[0], setDocumentUrl = _c[1];
    var _d = useState(false), isDownloading = _d[0], setIsDownloading = _d[1];
    var _e = useState(), nextPage = _e[0], setNextPage = _e[1];
    var history = useHistory();
    var downloadDocument = function (documentId) {
        setIsDownloading(true);
        services
            .getDownloadDeclarationDocument(documentId)
            .then(function (blob) {
            saveAs(blob, "DeclarationDocument-".concat(documentId, ".pdf"));
        })
            .finally(function () {
            setIsDownloading(false);
        });
    };
    var columns = [
        {
            id: 'name',
            description: 'Declaration',
        },
        {
            id: 'confirm',
            description: 'Confirm',
            sort: false,
            render: function (column, row) {
                return (React.createElement(InputCheckbox, { id: 'viewed_' + row.declarationDocumentId, defaultValue: row.accepted, dataValue: row.declarationDocumentId, onToggle: setDocumentViewed }));
            },
        },
        {
            id: 'view',
            description: 'View',
            sort: false,
            render: function (column, row) {
                return (React.createElement(Button, { variant: "outline", childClasses: "c-submit-button", type: "button", disabled: isDownloading, onClick: function () { return downloadDocument(row.declarationDocumentId); } }, "View"));
            },
        },
    ];
    var setDocumentViewed = function (e) {
        var id = e.currentTarget.getAttribute('data-value');
        var docs = __spreadArray([], declarations, true);
        docs.filter(function (d) { return d.declarationDocumentId === Number(id); })[0].accepted = e.currentTarget.checked;
        setDeclarations(docs);
    };
    var saveDeclarationStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var declarationIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    declarationIds = declarations.map(function (d) { return d.declarationDocumentId; });
                    return [4 /*yield*/, services.saveDeclarations(caseId, formId, declarationIds)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchDocuments(caseId, formId)];
                case 2:
                    _a.sent();
                    history.push(nextPage.path, location.state);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchDocuments = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var declarations;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, services.getDeclarations(caseId, formId)];
                case 1:
                    declarations = _b.sent();
                    if (declarations) {
                        setDeclarations((_a = data !== null && data !== void 0 ? data : declarations.data) !== null && _a !== void 0 ? _a : []);
                    }
                    else {
                        setDeclarations(data !== null && data !== void 0 ? data : []);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (caseId && formId && !documentUrl) {
            fetchDocuments(caseId, formId);
            setDocumentUrl(services.getDeclarationDocumentUrl());
        }
    }, [caseId, formId, documentUrl]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { className: "u-fs-3 u-mb-4" }, "Declarations"),
            React.createElement("span", { className: "u-fs-2" }, "Please view each declaration and tick to confirm that you have read and agreed to each one."),
            React.createElement(Grid, { pinned: 'right', rowData: declarations, columns: columns, noRowsMessage: "No existing declarations" })),
        React.createElement(CaseNavigation, { pages: pages, workflowSteps: steps, location: location, setTargetPage: setNextPage, onNextClick: saveDeclarationStatus, nextDisabled: declarations.filter(function (d) { return !d.accepted; }).length > 0 })));
};
